import type { ComponentContentSchema } from '@vibesites/runtime';
import { EditableToken } from '@vibesites/runtime/react';

// Special offers are not used on Price Brothers sites at this time. This
// override replaces the inherited vantage banner + floating pill with a
// no-op so nothing renders on any page. The hidden anchor keeps the schema
// key wired for the inline editor if offers are re-enabled later.
export function SpecialOfferBanner() {
  return (
    <EditableToken
      path="specialofferbanner.title_display"
      defaultValue=""
      as="span"
      className="hidden"
      style={{ display: 'none' }}
    >
      {''}
    </EditableToken>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'SpecialOfferBanner',
  displayName: 'Special Offer Banner',
  tokens: {
    'specialofferbanner.title_display': {
      label: 'Offer Title',
      type: 'text',
      defaultValue: '',
    },
  },
};

(SpecialOfferBanner as unknown as { contentSchema: ComponentContentSchema }).contentSchema = contentSchema;

export default SpecialOfferBanner;
